export const ACTIONS = {
    READ: 'read',
    UPDATE: 'update',
    CREATE: 'create',
    DELETE: 'delete',
    ARCHIVE: 'archive',
    UNARCHIVE: 'unarchive',
    DOWNLOAD: 'download',
    ASSIGN: 'assign',
    SAVE_DRAFT: 'save_draft',
    SUBMIT: 'submit',
    COMPLETE: 'complete',
    REOPEN: 'reopen',
    TRANSITION: 'transition',
    APPROVE: 'approve',
    UPLOAD: 'upload',
    RESTORE: 'restore',
    EXPORT: 'export',
    ANALYZE: 'analyze',
    REVOKE: 'revoke',
    FLAG: 'flag',
    FILTER: 'filter',
    OPEN: 'open',
    SETTINGS: 'settings',
    PUBLISH: 'publish',
    CLONE: 'clone',
    VERIFY: 'verify',
    REJECT: 'reject',
    CLOSE_OUT: 'close_out',
    COMMENT: 'comment',
    RETURN: 'return',
    DEFER: 'defer',
    FINALIZE: 'finalize',
    REMOVE: 'remove',
    SHARE: 'share',
    LINK: 'link',
    JOIN: 'join',
    SEND: 'send',
    RATE: 'rate',
    MARK: 'mark',
    MANAGE: 'manage',
    RENEW: 'renew',
    SET_DEFAULT: 'set_default',
    REASSIGN: 'reassign',
    UNASSIGN: 'unassign',
    CLOSE: 'close',
    RESOLVE: 'resolve',
    RETIRE: 'retire',
    COMMENT_PRIVATE: 'comment_private',
    CYCLE: 'cycle',
    /** Header edits by the approving Yard Manager / Transport Manager (rego, driver,
        fleet) at any point while the run is live — a distinct grant from `update`
        (reworking the draft). */
    EDIT: 'edit',
    /** Sending a delivery back to In Progress from Pending Photos so a count can be
        corrected after the pick was finished. Its own grant (Transport Manager) rather
        than `update`, which the whole pick crew holds. */
    RETURN_TO_PICKING: 'return_to_picking',
    /** Sending a Completed return back to Assigned so the yard can continue the count
        (missed lines, a line that turned up after sign-off). Its own grant (Transport
        Manager / Yard Manager) rather than `update`/`assign`, which the count crew holds. */
    RETURN_TO_COUNT: 'return_to_count',
    /** Adding/correcting/removing the extra trucks on a delivery (Transport Manager).
        Each vehicle carries its own load-photo requirement, so this is its own grant
        rather than part of `edit`. */
    EDIT_VEHICLES: 'edit_vehicles',
    UPDATE_PENDING_REPAIR: 'update_pending_repair',
    DELETE_PENDING_REPAIR: 'delete_pending_repair',
    UPDATE_APPROVED_REPAIR: 'update_approved_repair',
    DELETE_APPROVED_REPAIR: 'delete_approved_repair',
    QUALIFICATION: 'qualification',
    QUALIFICATION_TYPE: 'qualification_type',
};

export const RESOURCES = {
    // Dashboard
    DASHBOARD: 'dashboard',
    DASHBOARD_SETTINGS: 'dashboard_settings',
    DASHBOARD_ANNOUNCEMENT: 'dashboard_announcement',
    DASHBOARD_QUICK_ACTIONS: 'dashboard_quick_actions',
    DASHBOARD_QUICK_LINKS: 'dashboard_quick_links',

    // Activity Centre
    ACTIVITY_CENTRE: 'activity_centre',

    // Recognition
    RECOGNITION: 'recognition',
    RECOGNITION_COMMENT: 'recognition_comment',
    RECOGNITION_REACTION: 'recognition_reaction',
    SHARE_RECOGNITION: 'share_recognition',
    RECOGNITION_CREATED_BY_ME: 'recognition_created_by_me',

    // Organisation
    ORGANISATION_CHART: 'organisation chart',

    // Departments
    DEPARTMENT_LIST: 'department_list',
    ALL_DEPARTMENT_DETAILS: 'all_department_details',
    OWN_DEPARTMENT_DETAILS: 'own_department_details',
    DEPARTMENT: 'department',
    ARCHIVE_DEPARTMENT: 'archive_department',
    UNARCHIVE_DEPARTMENT: 'unarchive_department',
    DEPARTMENT_MANAGER: 'department_manager',

    // HR Dashboard — read-only people, compliance and recruitment metrics.
    HR_DASHBOARD: 'hr_dashboard',

    // Performance module (prototype Rev 2). See backend constants for the grant matrix.
    PERFORMANCE_MY_GOALS: 'performance_my_goals',
    PERFORMANCE_MY_REVIEW: 'performance_my_review',
    PERFORMANCE_TEAM: 'performance_team',
    PERFORMANCE_COMPANY_GOAL: 'performance_company_goal',
    PERFORMANCE_DEPARTMENT_GOAL: 'performance_department_goal',
    PERFORMANCE_SCHEDULE: 'performance_schedule',
    PERFORMANCE_CALIBRATION: 'performance_calibration',
    PERFORMANCE_TOUCHPOINT: 'performance_touchpoint',

    // AI Usage (docs/AI-USAGE-DESIGN-PROMPT.md §5).
    AI_USAGE_DASHBOARD: 'ai_usage_dashboard',
    AI_USAGE_LOG: 'ai_usage_log',
    AI_USAGE_SETTINGS: 'ai_usage_settings',

    // People
    PERSON: 'person',
    PERSON_PAGE: 'person_page',
    PERSON_I_MANAGE_PAGE: 'person_i_manage_page',
    PERSON_DEPARTMENTS: 'person_departments',
    PERSON_DETAIL_PAGE: 'person_detail_page',
    PERSON_ATTACHMENTS: 'person_attachments',
    PERSON_SETTINGS: 'person_settings',

    // Job Roles
    JOB_ROLE: 'job_role',
    JOB_ROLE_LIST: 'job_role_list',
    JOB_ROLE_DETAIL: 'job_role_detail',
    JOB_ROLE_MY_JOB_ROLE: 'job_role_my_job_role',
    JOB_ROLE_DESCRIPTION: 'job_role_description',
    JOB_ROLE_OUTCOMES: 'job_role_outcomes',
    JOB_ROLE_DUTIES: 'job_role_duties',
    JOB_ROLE_ATTACHMENTS: 'job_role_attachments',
    JOB_ROLE_SETTINGS: 'job_role_settings',
    JOB_TITLE: 'job_title',
    JOB_ROLE_LOCATION: 'job_role_location',
    JOB_GRADE: 'job_grade',

    // Procedures & Activities
    PROCEDURE: 'procedure',
    PROCEDURE_LIST: 'procedure_list',
    PROCEDURE_DETAIL_MEMBERSHIP: 'procedure_detail_membership',
    PROCEDURE_I_OWN: 'procedure_i_own',
    PROCEDURE_DESCRIPTION: 'procedure_description',
    PROCEDURE_IMPORTANCE: 'procedure_importance',
    PROCEDURE_INSTRUCTIONS: 'procedure_instructions',
    PROCEDURE_SYSTEMS: 'procedure_systems',
    PROCEDURE_LINKS: 'procedure_links',
    PROCEDURE_ATTACHMENTS: 'procedure_attachments',
    PROCEDURE_STAKEHOLDERS: 'procedure_stakeholders',
    PROCEDURE_PDF: 'procedure_pdf',
    PROCEDURE_ACTIVITY: 'procedure_activity',
    PROCEDURE_ACTIVITIES: 'procedure_activities',
    PROCEDURE_OWNERSHIP: 'procedure_ownership',
    ACTIVITY_IMPORTANCE: 'activity_importance',
    ACTIVITY_INSTRUCTIONS: 'activity_instructions',
    ACTIVITY_LINKS: 'activity_links',
    ACTIVITY_ATTACHMENTS: 'activity_attachments',

    // Training
    TRAINING: 'training',
    // Training
    TRAINING_PLAN: 'training_plan',
    TRAINING_PLAN_LIST: 'training_plan_list',
    TRAINING_PLAN_DETAIL: 'training_plan_detail',
    TRAINING_PLANS_MY_STAFF: 'training_plans_my_staff',
    TRAINING_PLAN_STATUS: 'training_plan_status',
    TRAINING_PLAN_DATES: 'training_plan_dates',
    TRAINING_PLAN_NOTES: 'training_plan_notes',
    TRAINING_PLAN_PROCEDURES: 'training_plan_procedures',
    TRAINING_PLAN_PDF: 'training_plan_pdf',
    TRAINING_PLAN_TEMPLATE: 'training_plan_template',
    TRAINING_PLAN_SETTINGS: 'training_plan_settings',
    // Recruitment
    RECRUITMENT_MODULE: 'recruitment_module',
    RECRUITMENT_DASHBOARD: 'recruitment_dashboard',
    RECRUITMENT_DASHBOARD_FILTERED: 'recruitment_dashboard_filtered',
    RECRUITMENT_REQUEST: 'recruitment_request',
    RECRUITMENT_REQUEST_LIST: 'recruitment_request_list',
    RECRUITMENT_REQUEST_DETAIL_ALL: 'recruitment_request_detail_all',
    RECRUITMENT_REQUEST_DETAIL_CREATED_BY_ME: 'recruitment_request_detail_created_by_me',
    RECRUITMENT_REQUEST_CREATED_BY_ME: 'recruitment_request_created_by_me',
    CANDIDATE: 'candidate',
    CANDIDATE_LIST: 'candidate_list',
    CANDIDATE_DETAIL: 'candidate_detail',
    CANDIDATE_STATUS: 'candidate_status',
    INTERVIEW: 'interview',
    CANDIDATE_INTERVIEW_SCHEDULE: 'candidate_interview_schedule',
    INTERVIEW_DETAIL: 'interview_detail',
    INTERVIEW_STATUS: 'interview_status',
    INTERVIEW_TEMPLATE: 'interview_template',
    INTERVIEW_TEMPLATE_LIST: 'interview_template_list',
    INTERVIEW_TEMPLATE_DETAIL: 'interview_template_detail',
    CORE_VALUE: 'core_value',
    CORE_VALUE_LIST: 'core_value_list',
    INTERVIEW_QUESTION: 'interview_question',
    INTERVIEW_QUESTION_LIST: 'interview_question_list',
    RECRUITMENT_ANALYTICS: 'recruitment_analytics',
    RECRUITMENT_SETTINGS: 'recruitment_settings',
    CANDIDATE_NOTES_DETAIL: 'candidate_notes_detail',
    CANDIDATE_ATTACHMENT_DETAIL: 'candidate_attachment_detail',
    CANDIDATE_MANAGE_REJECT: 'candidate_manage_reject',
    CANDIDATE_MANAGE_STATUS_MANAGEMENT: 'candidate_manage_status_management',
    CANDIDATE_MANAGE_EXTEND_OFFER: 'candidate_manage_extend_offer',
    CANDIDATE_OFFER: 'candidate_offer',
    OFFER_TEMPLATE: 'offer_template',

    // Onboarding
    ONBOARDING_DASHBOARD: 'onboarding_dashboard',
    ONBOARDING_REQUEST_LIST: 'onboarding_request_list',
    MY_ONBOARDING_ASSIGNMENTS: 'my_onboarding_assignments',
    ONBOARDING_REQUEST: 'onboarding_request',
    ONBOARDING_REQUEST_DETAIL: 'onboarding_request_detail',
    ONBOARDING_REQUEST_DETAIL_CREATED_BY_ME: 'onboarding_request_detail_created_by_me',
    ONBOARDING_REQUEST_STATUS: 'onboarding_request_status',
    ONBOARDING_REQUEST_DATES: 'onboarding_request_dates',
    ONBOARDING_REQUEST_NOTES: 'onboarding_request_notes',
    ONBOARDING_IT_STEP: 'onboarding_it_step',
    ONBOARDING_HR_STEP: 'onboarding_hr_step',
    ONBOARDING_FINANCE_STEP: 'onboarding_finance_step',
    ONBOARDING_ASSIGNMENTS: 'onboarding_assignments',
    COMPLETE_ONBOARDING_ASSIGNMENTS: 'complete_onboarding_assignments',
    ONBOARDING_CHECKLIST_ITEMS: 'onboarding_checklist_items',
    ONBOARDING_IT_EQUIPMENT: 'onboarding_it_equipment',
    ONBOARDING_SOFTWARE_ACCESS: 'onboarding_software_access',
    ONBOARDING_SYSTEMS_ACCESS: 'onboarding_systems_access',
    ONBOARDING_TOOLS: 'onboarding_tools',
    ONBOARDING_SECURITY: 'onboarding_security',
    ONBOARDING_HR_DOCUMENTS: 'onboarding_hr_documents',
    ONBOARDING_HR_POLICIES: 'onboarding_hr_policies',
    ONBOARDING_HR_INDUCTION: 'onboarding_hr_induction',
    ONBOARDING_FINANCE_PAYROLL: 'onboarding_finance_payroll',
    ONBOARDING_FINANCE_CARDS: 'onboarding_finance_cards',
    ONBOARDING_FINANCE_SYSTEMS: 'onboarding_finance_systems',
    ONBOARDING_FINANCE_ASSETS: 'onboarding_finance_assets',
    ONBOARDING_ACTIVITY_LOG: 'onboarding_activity_log',
    ONBOARDING_SETTINGS: 'onboarding_settings',

    // Offboarding
    OFFBOARDING_REQUEST: 'offboarding_request',
    OFFBOARDING_REQUEST_CREATED_BY_ME: 'offboarding_request_created_by_me',
    OFFBOARDING_CHECKLIST: 'offboarding_checklist',
    OFFBOARDING_IT_STEP: 'offboarding_it_step',
    OFFBOARDING_HR_STEP: 'offboarding_hr_step',
    OFFBOARDING_FINANCE_STEP: 'offboarding_finance_step',
    OFFBOARDING_PROGRESS: 'offboarding_progress',

    // Assets
    ASSET: 'asset',
    ASSET_ASSIGNMENT: 'asset_assignment',
    ASSET_STATUS: 'asset_status',
    ASSET_MAINTENANCE: 'asset_maintenance',
    ASSET_REPAIR: 'asset_repair',
    ASSET_REPAIR_IMAGE: 'asset_repair_image',
    ASSET_SUMMARY: 'asset_summary',
    ASSET_TYPE: 'asset_type',
    ASSET_VALUE: 'asset_value',
    ASSET_REPORT: 'asset_report',
    ASSET_DATA: 'asset_data',
    ASSET_WARRANTY: 'asset_warranty',
    ASSET_ACTIVITY_LOG: 'asset_activity_log',
    ASSET_MAINTENANCE_HISTORY: 'asset_maintenance_history',
    ASSET_DASHBOARD: 'asset_dashboard',
    ASSET_SETTINGS: 'asset_settings',
    INSPECTION_TEMPLATE: 'inspection_template',
    INSPECTION_TEMPLATE_ITEM: 'inspection_template_item',
    ASSET_REMINDER: 'asset_reminder',
    ASSET_INSPECTION: 'asset_inspection',
    ASSET_DASHBOARD_WIDGET: 'asset_dashboard_widget',
    ASSET_REPORT_TAB: 'asset_report_tab',
    ASSET_ELECTRICAL_REGISTER_TAB: 'asset_electrical_register_tab',
    ASSET_LIFTING_REGISTER_TAB: 'asset_lifting_register_tab',
    ASSET_SHCEDULED_MAINTENANCE_TAB: 'asset_shceduled_maintenance_tab',

    // Business Systems
    BUSINESS_SYSTEMS_MODULE: 'business_systems_module',
    BUSINESS_SYSTEM: 'business_system',
    BUSINESS_SYSTEM_SUMMARY: 'business_system_summary',
    BUSINESS_SYSTEM_COST: 'business_system_cost',
    BUSINESS_SYSTEM_LICENSE: 'business_system_license',
    BUSINESS_SYSTEM_USER: 'business_system_user',
    BUSINESS_SYSTEM_VENDOR: 'business_system_vendor',
    BUSINESS_SYSTEM_ISSUES: 'business_system_issues',
    BUSINESS_SYSTEM_CATEGORY: 'business_system_category',
    BUSINESS_SYSTEM_DATA: 'business_system_data',
    BUSINESS_SYSTEM_ACTIVITY_LOG: 'business_system_activity_log',
    BUSINESS_SYSTEM_HISTORY: 'business_system_history',

    // Policies & Memos
    POLICY: 'policy',
    POLICY_VERSION: 'policy_version',
    MEMO: 'memo',
    POLICY_ASSIGNMENT: 'policy_assignment',
    POLICY_SIGNATURE: 'policy_signature',
    POLICY_SUMMARY: 'policy_summary',
    POLICY_STATUS: 'policy_status',
    POLICY_DATA: 'policy_data',
    POLICY_ACTIVITY_LOG: 'policy_activity_log',
    POLICY_HISTORY: 'policy_history',

    // Decisions
    DECISION: 'decision',
    DECISIONS_I_PARTICIPATE_IN: 'decisions_i_participate_in',
    DECISION_CREATED_BY_ME: 'decision_created_by_me',
    DECISION_VOTE: 'decision_vote',
    DECISION_VOTING: 'decision_voting',
    DECISION_PARTICIPANT: 'decision_participant',
    DECISION_ATTACHMENT: 'decision_attachment',
    DECISION_OUTCOME: 'decision_outcome',
    DECISION_FOLLOWUP: 'decision_followup',
    DECISION_SUMMARY: 'decision_summary',
    DECISION_STATUS: 'decision_status',
    DECISION_DATA: 'decision_data',
    DECISION_RECORD: 'decision_record',
    DECISION_ACTIVITY_LOG: 'decision_activity_log',
    DECISION_HISTORY: 'decision_history',

    // Meetings
    MEETING: 'meeting',
    MEETING_AGENDA: 'meeting_agenda',
    MEETING_ATTENDEE: 'meeting_attendee',
    MEETING_ACTION: 'meeting_action',
    MEETING_NOTES: 'meeting_notes',
    MEETING_FEEDBACK: 'meeting_feedback',
    MEETING_SUMMARY: 'meeting_summary',
    MEETING_REMINDER: 'meeting_reminder',
    ONE_ON_ONE_MEETING: '1_1_meeting',
    ONE_ON_ONE_AGENDA: '1_1_agenda',
    ONE_ON_ONE_NOTES: '1_1_notes',
    ONE_ON_ONE_ACTION: '1_1_action',
    ONE_ON_ONE_MEETING_COMPLETE: '1_1_meeting_complete',
    ONE_ON_ONE_INVITE: '1_1_invite',

    // Inventory & PPE
    INVENTORY_ITEM: 'inventory_item',
    INCOMING_INVENTORY: 'incoming_inventory',
    INVENTORY_ISSUANCE: 'inventory_issuance',
    INVENTORY_WORKER: 'inventory_worker',
    LOCATION: 'location',
    INVENTORY_ISSUANCE_LIMIT: 'inventory_issuance_limit',
    INVENTORY: 'inventory',
    INVENTORY_CATEGORY: 'inventory_category',
    INVENTORY_LOCATION: 'inventory_location',
    INVENTORY_SUPPLIER: 'inventory_supplier',
    INVENTORY_STOCK_LOG: 'inventory_stock_log',
    INVENTORY_SETTING: 'inventory_setting',
    INVENTORY_RULE: 'inventory_rule',

    // System & Finance
    REPORT: 'report',
    PERMISSIONS: 'permissions',
    INSURANCE_POLICY: 'insurance_policy',
    PREMIUM_FUNDING: 'premium_funding',
    POLICY_ATTACHMENT: 'policy_attachment',
    POLICY_NOTE: 'policy_note',
    RENEWAL: 'renewal',
    POLICIES: 'policies',
    DIRECT_DEBIT_MODULE: 'direct_debit_module',
    DIRECT_DEBIT: 'direct_debit',
    DIRECT_DEBIT_ADHOC_PAYMENT: 'direct_debit_adhoc_payment',
    DIRECT_DEBIT_APPROVAL_REQUEST: 'direct_debit_approval_request',
    DIRECT_DEBIT_APPROVAL_STATUS: 'direct_debit_approval_status',
    DIRECT_DEBIT_STATS: 'direct_debit_stats',
    DIRECT_DEBIT_FINANCE_COMPANY: 'direct_debit_finance_company',
    DIRECT_DEBIT_TRANSACTIONS: 'direct_debit_transactions',
    DIRECT_DEBIT_PERMISSIONS: 'direct_debit_permissions',
    PROCEDURE_DETAIL: 'procedure_detail',

    //External Partner
    EXTERNAL_PARTNER: 'external_partner',

    // Delegation
    DELEGATION_DEVELOPMENT: 'delegation_development',

    // Qualification
    QUALIFICATION: 'qualification',
    QUALIFICATION_TYPE: 'qualification_type',
    QUALIFICATION_GROUP: 'qualification_group',
    QUALIFICATION_DEFAULT: 'qualification_default',
    QUALIFICATION_PRESET: 'qualification_preset',
    QUALIFICATION_SETTINGS: 'qualification_settings',

    // Service Desk
    SERVICE_DESK_REQUESTER: 'service_desk_requester',
    SERVICE_DESK_ADMIN: 'service_desk_admin',
    SERVICE_DESK_TEAM_ADMIN: 'service_desk_team_admin',
    SERVICE_DESK_AGENT: 'service_desk_agent',
    SERVICE_DESK_AGENT_VIEWER: 'service_desk_agent_viewer',

    // Safety
    HAZARDOUS_CHEMICAL: 'hazardous_chemical',
    HAZARDOUS_CHEMICAL_LIST: 'hazardous_chemical_list',
    HAZARDOUS_CHEMICAL_DETAIL: 'hazardous_chemical_detail',
    HAZARDOUS_CHEMICAL_SETTINGS: 'hazardous_chemical_settings',
    INCIDENT_INJURY: 'incident_injury',
    INCIDENT_INJURY_LIST: 'incident_injury_list',
    INCIDENT_INJURY_DETAIL: 'incident_injury_detail',
    INCIDENT_INJURY_SETTINGS: 'incident_injury_settings',
    SAFETY_WALK: 'safety_walk',
    SAFETY_WALK_LIST: 'safety_walk_list',
    SAFETY_WALK_DETAIL: 'safety_walk_detail',
    SAFETY_WALK_SETTINGS: 'safety_walk_settings',
    SAFETY_OBSERVATION: 'safety_observation',
    SAFETY_OBSERVATION_LIST: 'safety_observation_list',
    SAFETY_OBSERVATION_DETAIL: 'safety_observation_detail',
    SAFETY_OBSERVATION_COMMENT: 'safety_observation_comment',
    SAFETY_DASHBOARD: 'safety_dashboard',
    SAFETY_MY_TASKS: 'safety_my_tasks',

    // Attendance & Leave
    ATTENDANCE_ADMIN: 'attendance_admin',
    ATTENDANCE_SETTINGS: 'attendance_settings',
    LEAVE_BALANCES_TAB: 'leave_balances_tab',
    LEAVE_POLICY_SETTINGS_TAB: 'leave_policy_settings_tab',
    LEAVE_AUDIT_TRAIL_TAB: 'leave_audit_trail_tab',
    LEAVE_DELEGATION_AUTHORITY_TAB: 'leave_delegation_authority_tab',
    LEAVE_ACCRUALS_TAB: 'leave_accruals_tab',
    LEAVE_DAILY_HOURS_TAB: 'leave_daily_hours_tab',
    LEAVE_BALANCE_MOVEMENTS_TAB: 'leave_balance_movements_tab',

    // Lists (shared reference data)
    LIST_CUSTOMER: 'list_customer',
    LIST_VENDOR: 'list_vendor',
    LIST_BRANCH: 'list_branch',
    LIST_PROJECT: 'list_project',

    // Stock (STOCK.md §11/§11b) — mirrors backend/constants/permissions.constants.js.
    // See that file for how STOCK.md §11's dotted permission names map onto
    // resource + action, and for the §11b global-role `manage` permissions.
    STOCK: 'stock',
    STOCK_DASHBOARD: 'stock_dashboard',
    STOCK_ADMIN: 'stock_admin',
    STOCK_INVENTORY_CONTROLLER: 'stock_inventory_controller',
    STOCK_YARD_MEMBER: 'stock_yard_member',
    STOCK_YARD_MANAGER: 'stock_yard_manager',
    STOCK_PRODUCT: 'stock_product',
    STOCK_DELIVERY_ORDER: 'stock_delivery_order',
    STOCK_RETURN_ORDER: 'stock_return_order',
    STOCK_IMPORT_ORDER: 'stock_import_order',
    STOCK_TRANSFER_ORDER: 'stock_transfer_order',
    STOCK_RECEIPT: 'stock_receipt',
    STOCK_ORDER_ENTRY: 'stock_order_entry',
    STOCK_VOID: 'stock_void',
    STOCK_PHOTO: 'stock_photo',
    // Source documents (§12.4): attaching one rides on create:stock_photo; removing a
    // wrongly attached one is a separate grant (delete:stock_document) so who may delete
    // source paperwork stays configurable independently of who may attach photos.
    STOCK_DOCUMENT: 'stock_document',
    STOCK_COMMENT: 'stock_comment',
    // Delivery notification settings (§4 workflow).
    STOCK_DELIVERY_SETTINGS: 'stock_delivery_settings',
    // Number of packs on the shipment: the advisory counts typed in on a delivery
    // (stillages, cages, boards, empties). Its own resource so the counts can be opened
    // and filled in by everyone who can see a delivery, without touching the workflow.
    STOCK_DELIVERY_PACKS: 'stock_delivery_packs',

    // Procurement → Purchase Orders (a sub-section of Stock). Mirrors the prototype's
    // permission strings exactly, and backend/constants/permissions.constants.js:
    //   create:purchase_order_issue / _receipt / _close_short / _cancel / _entry are
    //   separate resources so "who may issue", "who may receive" and "who may write off"
    //   stay independently configurable instead of collapsing into one update grant.
    PURCHASE_ORDER: 'purchase_order',
    PURCHASE_ORDER_APPROVAL: 'purchase_order_approval',
    PURCHASE_ORDER_ISSUE: 'purchase_order_issue',
    PURCHASE_ORDER_RECEIPT: 'purchase_order_receipt',
    PURCHASE_ORDER_CLOSE_SHORT: 'purchase_order_close_short',
    PURCHASE_ORDER_CANCEL: 'purchase_order_cancel',
    PURCHASE_ORDER_ENTRY: 'purchase_order_entry',
    PURCHASE_ORDER_PHOTO: 'purchase_order_photo',
    PURCHASE_ORDER_DOCUMENT: 'purchase_order_document',
    PURCHASE_ORDER_COMMENT: 'purchase_order_comment',
    PURCHASE_ORDER_SETTINGS: 'purchase_order_settings',

    // Learning (LEARNING.md §4) — mirrors backend/constants/permissions.constants.js.
    LEARNING_ADMIN: 'learning_admin',
    COURSE: 'course',
    COURSE_CATEGORY: 'course_category',
    COURSE_ASSIGNMENT: 'course_assignment',
    COURSE_ENROLLMENT: 'course_enrollment',
    COURSE_CERTIFICATE: 'course_certificate',
    PERSON_LEARNING: 'person_learning',
    LEARNING_SETTINGS: 'learning_settings',
};
